module.exports = __webpack_public_path__ + "img/female-avatar.6edde591.png";